export const findPromoCode = (content: string | null | undefined) => {
  const promoCodeRegexPattern =
    /(Apply promo code |enter )([\w]*)( at checkout| to claim your discount)/;
  const promoCodeMatches = content?.match(promoCodeRegexPattern);
  return promoCodeMatches ? promoCodeMatches[2] : "";
};
